import logo from "../assets/images/eml-logo-light.svg";
import logodark from "../assets/images/footer-logo.svg";
import "../App.css";
import useAuth from "../hooks/useAuth";
import Theme from "./Theme";
import useTheme from "../hooks/useTheme";
import ReportHubLogo from "./logo/ReportHubLogo";
import AppLauncher from "./appLauncher";

const Header = () => {
  const { userName, logout, setUserName } = useAuth();
  const { theme } = useTheme();

  const handleMenuClick = () => {
    setUserName("");
    logout();
  };

  return (
    <div className="header">
      <div className="d-flex align-items-center h-100">
        {userName && (
          <div className="header-launcher">
            <AppLauncher />
          </div>
        )}
        <div className="p-2 flex-grow-1 d-flex align-items-center">
          <img src={theme === "light" ? logo : logodark} className="logo" alt="logo" />
          <span className="header-app-logo">
            <ReportHubLogo variant="static" />
          </span>
        </div>
        <div className="header-actions">
          <Theme />
          {userName && (
            <div className="dropdown user-menu">
              <button
                className="btn btn-outline-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {userName}
              </button>
              <div className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                <a className="dropdown-item" href="#" onClick={handleMenuClick}>
                  Logout
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
